import React, { useContext } from "react";
import { Stack, Typography, Paper } from "@mui/material";
import { UserDetailsContext } from "../Context/userDetailsContext";
import RequestServiceForm from "../Components/RequestServiceForm/index";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router";
import PersonIcon from "@mui/icons-material/Person";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const RequestService = () => {
  const { userDetails } = useContext(UserDetailsContext);
  const location = useLocation();
  const { state } = location;

  return (
    <Stack gap={3} sx={{ padding: 3 }}>
      <Stack
        direction={isMobile ? "column" : "row"}
        justifyContent={"space-between"}
        gap={2}
      >
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 300,
            border: "2px solid",
            borderColor: "primary.main",
            boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.15)",
          }}
        >
          <PersonIcon sx={{ mr: 1, color: "primary.main" }} />
          <Typography variant="h6" color="primary.main">بيانات مقدم الطلب</Typography>
        </Paper>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 300,
            border: "2px solid",
            borderColor: "success.main",
            boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.15)",
          }}
        >
          <AttachMoneyIcon sx={{ mr: 1, color: "success.main" }} />
          <Typography variant="h6" color="success.main">{`${state?.applicationFee} ${state?.currency?.[0]?.name}`}</Typography>
        </Paper>
      </Stack>

      <RequestServiceForm />
    </Stack>
  );
};
export default RequestService;
